import { useEffect, useState } from 'react';
import { PasswordRequirement } from './PasswordRequirement/PasswordRequirement';
import styles from './PasswordRequirements.module.scss';

const passwordRequirements = [
  {
    label: 'Minimum 8 characters',
    regexp: /.{8,}/,
    isMatched: false,
  },
  {
    label: 'Maximum 25 characters',
    regexp: /^.{0,25}$/,
    isMatched: false,
  },
  {
    label: '1 upper case character',
    regexp: /^(?=.*[A-Z]).*$/,
    isMatched: false,
  },
  {
    label: '1 lower case character',
    regexp: /^(?=.*[a-z]).*$/,
    isMatched: false,
  },
  {
    label: '1 special character',
    regexp: /^(?=.*[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/~]).*$/,
    isMatched: false,
  },
  {
    label: '1 number',
    regexp: /^(?=.*\d).+$/,
    isMatched: false,
  },
];

type Props = {
  currentPassword: string | undefined;
};

export const PasswordRequirements = ({ currentPassword }: Props) => {
  const [passwordRequirementsMatches, setPasswordRequirementsMatches] = useState(passwordRequirements);

  useEffect(() => {
    if (currentPassword === undefined) return;

    const withMatchedRequirements = passwordRequirements.map((item) => ({
      ...item,
      isMatched: !!currentPassword.match(item.regexp),
    }));

    setPasswordRequirementsMatches(withMatchedRequirements);
  }, [currentPassword]);

  return (
    <div className={styles.container}>
      {passwordRequirementsMatches.map((item) => (
        <PasswordRequirement isChecked={item.isMatched} text={item.label} key={item.label} />
      ))}
    </div>
  );
};
